import _trim from 'lodash/trim'

// GetCookie
export default class {
  csrf () {
    return this.getCookie('csrftoken')
  }

  getCookie (name) {
    let cookieValue = null
    if (document.cookie && document.cookie !== '') {
      let cookies = document.cookie.split(';')
      for (let cookie of cookies) {
        cookie = _trim(cookie)
        // Does this cookie string begin with the name we want?
        if (cookie.substring(0, name.length + 1) === (name + '=')) {
          cookieValue = decodeURIComponent(cookie.substring(name.length + 1))
          break
        }
      }
    }
    return cookieValue
  }
}
